import React from 'react';
import { Typography, Button } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useNavigate } from 'react-router-dom';
import abuja from './Assets/abuja.jpg';
import Header from './Header';

const useStyles = makeStyles((theme) => ({
  cityImg: {
    width: '100%',
    height: '100vh', // Full viewport height
    objectFit: 'cover',
    position: 'fixed', // Fixes the background in place
    top: 0,
    left: 0,
    zIndex: -1, // Sends it behind other elements
  },
  overlayText: {
    position: 'relative', // Keep overlay in place relative to the parent div
    zIndex: 10,
    top: '25%',
    textAlign: 'center',
    color: '#ffffff', // White text for contrast
    padding: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      top: '20%', // Adjust positioning for smaller screens
    },
  },
  homeText: {
    color: '#fff',
    fontWeight: 'bolder',
    fontSize: 'clamp(2rem, 6vw, 4rem)', // Responsive font size
    textShadow: '2px 2px 4px rgba(0, 0, 0, 0.7)', // Adds shadow for better readability
    marginBottom: theme.spacing(2),
  },
  homeBtn: {
    fontSize: 'clamp(1rem, 4vw, 1.5rem)', // Responsive button font size
    padding: '0.8rem 2rem',
    borderRadius: '25px',
    marginTop: theme.spacing(3),
    background: 'linear-gradient(45deg, #1976D2, #004BA0)', // Gradient for button
    color: '#fff',
    boxShadow: '3px 3px 10px rgba(0, 0, 0, 0.3)',
    '&:hover': {
      background: 'linear-gradient(45deg, #004BA0, #1976D2)', // Reverse gradient on hover
    },
  },
}));

function Home() {
  const classes = useStyles();
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate('/listings');
  };

  return (
    <>
      <Header />
      <div>
        <img src={abuja} className={classes.cityImg} alt="City view of Abuja" />
        <div className={classes.overlayText}>
          <Typography variant="h2" className={classes.homeText}>
            Find Your Next Property on PROPARTY Website
          </Typography>
          <Button variant="contained" className={classes.homeBtn} onClick={handleNavigate}>
            SEE ALL PROPERTIES
          </Button>
        </div>
      </div>
    </>
  );
}

export default Home;

// import React from 'react';
// import { Typography, Button } from '@mui/material';
// import { makeStyles } from '@mui/styles';
// import { useNavigate } from 'react-router-dom';
// import abuja from './Assets/abuja.jpg';
// import Header from './Header';

// const useStyles = makeStyles((theme) => ({
//   cityImg: {
//     width: '100%',
//     height: '92vh',
//     objectFit: 'cover',
//     [theme.breakpoints.down('md')]: {
//       height: '70vh', // Adjust height for medium screens
//     },
//     [theme.breakpoints.down('sm')]: {
//       height: '60vh', // Adjust height for smaller screens
//     },
//   },
//   overlayText: {
//     position: 'absolute',
//     zIndex: '100',
//     top: '15%',
//     left: '50%',
//     transform: 'translateX(-50%)', // Center the text horizontally
//     textAlign: 'center',
//     [theme.breakpoints.down('sm')]: {
//       top: '10%', // Adjust positioning for smaller screens
//     },
//   },
//   homeText: {
//     color: '#1976D2',
//     fontWeight: 'bolder',
//     fontSize: 'clamp(1.5rem, 5vw, 3rem)', // Responsive font size
//     marginBottom: theme.spacing(2),
//   },
//   homeBtn: {
//     fontSize: 'clamp(1rem, 4vw, 1.8rem)', // Responsive button font size
//     padding: '0.5rem 1.5rem',
//     borderRadius: '15px',
//     marginTop: theme.spacing(3),
//     boxShadow: '3px 3px 3px white',
//   },
// }));

// function Home() {
//   const classes = useStyles();
//   const navigate = useNavigate();

//   const handleNavigate = () => {
//     navigate('/listings');
//   };

//   return (
//     <>
//       <Header />
//       <div style={{ position: 'relative' }}>
//         <img src={abuja} className={classes.cityImg} alt="City view of Abuja" />
//         <div className={classes.overlayText}>
//           <Typography variant="h2" className={classes.homeText}>
//             Find Your Next Property on PROPARTY Website
//           </Typography>
//           <Button variant="contained" className={classes.homeBtn} onClick={handleNavigate}>
//             SEE ALL PROPERTIES
//           </Button>
//         </div>
//       </div>
//     </>
//   );
// }

// export default Home;

// worked prfectly, just that the responsiveness no too good
// import React from 'react';
// import { Typography, Button } from '@mui/material';
// import { makeStyles } from '@mui/styles';
// import { useNavigate } from 'react-router-dom';
// import abuja from './Assets/abuja.jpg';
// import Header from './Header';

// const useStyles = makeStyles((theme) => ({
//   cityImg: {
//     width: '100%',
//     height: '92vh',
//     objectFit: 'cover',
//     [theme.breakpoints.down('sm')]: {
//       height: '60vh', // Adjust height for smaller screens
//     },
//   },
//   overlayText: {
//     position: 'absolute',
//     zIndex: '100',
//     top: '20%',
//     left: '10%',
//     right: '10%',
//     textAlign: 'center',
//     [theme.breakpoints.down('sm')]: {
//       top: '10%', // Adjust positioning for smaller screens
//       left: '5%',
//       right: '5%',
//     },
//   },
//   homeText: {
//     color: '#1976D2',
//     fontWeight: 'bolder',
//     [theme.breakpoints.down('sm')]: {
//       fontSize: '2rem', // Smaller font size for mobile screens
//     },
//     [theme.breakpoints.down('xs')]: {
//       fontSize: '1.5rem',
//     },
//   },
//   homeBtn: {
//     fontSize: '2rem',
//     borderRadius: '15px',
//     marginTop: '2rem',
//     boxShadow: '3px 3px 3px white',
//     [theme.breakpoints.down('sm')]: {
//       fontSize: '1.5rem', // Smaller button for mobile
//       padding: '0.5rem 1rem',
//     },
//     [theme.breakpoints.down('xs')]: {
//       fontSize: '1.2rem', // Further adjustments for extra small devices
//       padding: '0.4rem 0.8rem',
//     },
//   },
// }));

// function Home() {
//   const classes = useStyles();
//   const navigate = useNavigate();

//   const handleNavigate = () => {
//     navigate('/listings');
//   };

//   return (
//     <>
//       <Header />
//       <div style={{ position: 'relative' }}>
//         <img src={abuja} className={classes.cityImg} alt="City view of Abuja" />
//         <div className={classes.overlayText}>
//           <Typography variant='h1' className={classes.homeText}>
//             Find Your Next Property on PROPARTY Website
//           </Typography>
//           <Button variant="contained" className={classes.homeBtn} onClick={handleNavigate}>
//             SEE ALL PROPERTIES
//           </Button>
//         </div>
//       </div>
//     </>
//   );
// }

// export default Home;